import { EnergySource } from "../shared/models/sections.model";

import { FlowsProductSelectSectionModel } from "./flows-product-select-section.model";

export namespace FlowsProductSelectSectionAction {
  export class Focused {
    static readonly type = "[FlowsProductSelectSection] Focused ";
    constructor(public payload: FlowsProductSelectSectionModel) {}
  }
  export class Reset {
    static readonly type = "[FlowsProductSelectSection] Reset ";
    constructor(public energySource: EnergySource) {}
  }
  export class Completed {
    static readonly type = "[FlowsProductSelectSection] Completed ";
    constructor(public payload: FlowsProductSelectSectionModel) {}
  }
  export class Disabled {
    static readonly type = "[FlowsProductSelectSection] Disabled ";
  }
}
